// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1Kmfi","infoBtn":"quickbooks_infoBtn__31afT","formBox":"quickbooks_formBox__3fAgF","formFooter":"quickbooks_formFooter__3MLSp"};